<template>
  <div class="d-flex justify-center">
    <t-text-input
      v-model="code"
      label="Cupom"
      density="compact"
      hide-details="auto"
      @input="code = code.toLocaleUpperCase()"
      @keydown.enter="submit"
      @keydown.space.prevent
    />
    <t-btn
      color="warning"
      class="ml-3"
      :loading="loader.loading('button')"
      height="40"
      @click="submit"
    >
      APLICAR
    </t-btn>
  </div>
</template>

<script setup lang="ts">
import { ref, computed, onMounted } from "vue";
import TTextInput from "../core/TTextInput.vue";
import TBtn from "../core/TBtn.vue";
import type Event from "@/types/Event";
import { useLoader } from "@/stores/loader";
import { useSnackbar } from "@/stores/snackbar";
import { useEventsStore } from "@/stores/events";
import { useCartStore } from "@/stores/cart";
import { useCheckoutStore } from "@/stores/checkout";

defineOptions({
  name: "CouponInput",
});

const loader = useLoader();
const snackbar = useSnackbar();
const cart = useCartStore();
const checkout = useCheckoutStore();

const code = ref<string>("");

const urlCodes = ref<string[]>([]);

const event = computed<Event | null>(() => useEventsStore().selected);

async function submit(): Promise<void> {
  const codes = [code.value, ...urlCodes.value].filter(c => c.length > 0);

  if (codes.length === 0 && cart.coupons.list.length === 0) return;

  if (!checkout.reservation) {
    snackbar.show("Reserva não encontrada para aplicar cupom!", "error");
    return;
  }

  if (!event.value) {
    snackbar.show("Evento não encontrado para aplicar cupom!", "error");
    return;
  }

  loader.increment("button");

  try {
    await cart.coupons.validate(codes, checkout.reservation, event.value);

    if (cart.coupons.list.length > 1) {
      snackbar.show("Cupom aplicado com sucesso!", "success");
    }
  } catch (e) {
    snackbar.error(e, "Não foi possível aplicar o cupom!");
    urlCodes.value = [];
  } finally {
    loader.decrement("button");
  }
}

function parseURLCodes() {
  const params = new URLSearchParams(window.location.search);
  const list = params.get("coupons");
  urlCodes.value = list?.split(",") ?? [];
}

onMounted(() => {
  parseURLCodes();
  submit();
});
</script>
